import { useState } from 'react';

import { CommonCardsGrid } from '#src/components/commonCard/CommonCardsGrid/index.tsx';
import type { Props as PlayerDrawerProps } from '#src/components/player/PlayerDrawer/index.tsx';
import { PlayerDrawer } from '#src/components/player/PlayerDrawer/index.tsx';
import type { CardResultsProps } from '#src/searchCards/AdvancedCardSearch/types.ts';
import { Pagination } from '#src/searchCards/Pagination/index.tsx';

export const PaginatedCommonCardsGrid = (props: CardResultsProps) => {
  const [cardOpened, setCardOpened] =
    useState<PlayerDrawerProps['cardOpened']>(null);

  return (
    <>
      <CommonCardsGrid
        {...props}
        onStatsClick={playerSlug =>
          setCardOpened({
            cardSlug: '',
            playerSlug,
          })
        }
      />
      <Pagination visible />
      <PlayerDrawer
        cardOpened={cardOpened}
        onClose={() => {
          setCardOpened(null);
        }}
      />
    </>
  );
};
